module.exports = "<p-panelMenu [model]=\"items\" [style]=\"{'width':'100%'}\"></p-panelMenu>           \n\n<app-session-checker></app-session-checker>"